import { render, staticRenderFns } from "./Reabertura.vue?vue&type=template&id=e7e6b8a2&lang=pug&"
import script from "./Reabertura.vue?vue&type=script&lang=js&"
export * from "./Reabertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports